import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pc",
  "use": "icon-pc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pc\"><defs><style type=\"text/css\"></style></defs><path d=\"M823.808 159.744H201.216c-22.528 0-40.96 18.432-40.96 40.96v323.584c-0.512 2.56-1.024 5.12-1.024 8.192 0 2.56 0.512 5.12 1.024 7.68v97.28c0 22.528 18.432 40.96 40.96 40.96h211.968v113.664h-38.912c-19.968 0-35.84 15.872-35.84 35.84s15.872 35.84 35.84 35.84h282.624c19.968 0 35.84-15.872 35.84-35.84s-15.872-35.84-35.84-35.84h-40.96v-113.664h207.872c22.528 0 40.96-18.432 40.96-40.96V200.704c0-22.528-18.432-40.96-40.96-40.96z m-30.72 71.68v262.656L231.936 496.64V231.424h561.152z m-248.832 561.152H484.864v-113.664h59.392v113.664z m-312.32-185.344V568.32l561.152-2.048v41.472H231.936z\" p-id=\"1215\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pc.svg
// module id = 17zL
// module chunks = 250